import React from "react";
import PropTypes from "prop-types";

import Table from "./DndTable";
import { DndPaginator } from "./components";
import useHeaderStatePersist from "./pluginHooks/useHeaderStatePersist";
import { withDragDropContext } from "./hoc/withDragDropContext";

const TableItem = ({ container: TableContainer, ...restProps }) =>
  TableContainer ? (
    <TableContainer {...restProps}>
      <Table {...restProps} />
    </TableContainer>
  ) : (
    <Table {...restProps} />
  );

TableItem.propTypes = {
  container: PropTypes.elementType,
};

const DndTableComponent = props => {
  const { tableEntities, ...restProps } = props;

  return tableEntities && tableEntities.length ? (
    <>
      {tableEntities.map((tableProps, index) => (
        <TableItem key={index} {...restProps} {...tableProps} />
      ))}
    </>
  ) : (
    <TableItem {...restProps} />
  );
};

DndTableComponent.propTypes = {
  tableEntities: PropTypes.array,
};

const DndTable = withDragDropContext(DndTableComponent);

DndTable.DndPaginator = DndPaginator;

export { DndTable, DndPaginator, useHeaderStatePersist };
